import ForgotPassword from '../pages/auth/forgot-password/ForgotPassword';
import ResetPassword from '../pages/auth/reset-password/ResetPassword';
import Login from '../pages/auth/login/Login';
import Register from '../pages/auth/register/Register';
import TMLogin from '../pages/auth/teamMembers/TMLogin';
import SocialAuth from '../pages/auth/socialAuth/SocialAuth';

const routesAuthentication = [
  {
    path: 'forgot-password',
    element: <ForgotPassword />,
  },
  {
    path: 'login',
    element: <Login />,
  },
  {
    path: 'reset-password',
    element: <ResetPassword />,
  },
  {
    path: 'register',
    element: <Register />,
  },
  {
    path: 'login/team-members',
    element: <TMLogin />,
  },
  {
    path: 'api/v1/auth/callback/:provider',
    element: <SocialAuth />,
  },
];

export default routesAuthentication;
